import { BaseFormDialog, useAuth, useHookForm } from '@cksoftware/react-base';
import { DlmsUser } from '../../globalModels/user/dlmsUser';
import { useEffect } from 'react';
import { cookieExists } from './cookieExists';
import { useSetProfileMutation } from './useSetProfileMutation';
import { useDisclosure } from '@chakra-ui/react';

type ProfileSelectForm = {
  profileId: number;
};

export const ProfileSelect = () => {
  const auth = useAuth<DlmsUser>();
  const disclosure = useDisclosure();
  const profileMutation = useSetProfileMutation();
  const { formMethods, fieldHelper } = useHookForm<ProfileSelectForm>();
  const fields = [
    fieldHelper
      .selectInput('profileId', {
        items:
          auth.user == undefined
            ? []
            : auth.user?.UserProfiles.map((x) => ({
                Label: `${x.FirstName} ${x.LastName} - ${x.CompanyName}`,
                Value: x.Id!
              }))
      })
      .withValidation({ required: {} })
  ];
  useEffect(() => {
    if (auth.isAuthenticated && !cookieExists('dlms-profile')) {
      if (auth.user?.UserProfiles.length == 1) {
        profileMutation.mutate(auth.user.UserProfiles[0].Id!);
      } else {
        disclosure.onOpen();
      }
    }
  }, [auth.isAuthenticated]);

  return (
    <>
      <BaseFormDialog<ProfileSelectForm>
        isLoading={false}
        disclosure={disclosure}
        fields={fields}
        hideCloseButton={true}
        closeOnEsc={false}
        disableCloseOnClick={true}
        header={'Select Profile'}
        formMethods={formMethods}
        onSubmit={async (val) => {
          await profileMutation.mutateAsync(val.profileId);
          disclosure.onClose();
          window.location.reload();
        }}
      />
    </>
  );
};
